module.exports = __webpack_public_path__ + "img/4.d8e269d7.jpg";